import React from 'react';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/brand/logo-oh-belleza.png`;

export default function BrandLogo({ variant = 'sidebar' }) {
  return (
    <div className={`admin-brand admin-brand-${variant}`}>
      <img src={LOGO_SRC} alt="¡Oh! Belleza" className="admin-brand-img" />
    </div>
  );
}
